import { Paperclip } from "lucide-react";

import { getModelLink } from "components/LogItem/messages/modelLinks";

export function renderAttachmentCreatedMessage({
  user_name,
  attachment_info,
  model_id,
  model_type,
  campaign_id,
}) {
  return (
    <p>
      {user_name} added the file &quot;{attachment_info?.file_name}&quot; to{" "}
      {getModelLink(model_id, model_type, { campaign_id })}.
    </p>
  );
}

export const ATTACHMENT_EVENTS = {
  "attachment.created": {
    title: "Attachment Created",
    icon: Paperclip,
    message: renderAttachmentCreatedMessage,
  },
  "attachment.deleted": {
    title: "Attachment Deleted",
    icon: Paperclip,
    message: ({
      user_name,
      attachment_info: { file_name },
      model_id,
      model_type,
      campaign_id,
    }) => (
      <p>
        {user_name} deleted the file &quot;{file_name}&quot; from{" "}
        {getModelLink(model_id, model_type, { campaign_id })}.
      </p>
    ),
  },
};
